import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu';

import type {
  ManageSitePageSidePanels,
  SitePage,
  FlattenPage,
} from 'src/types/page-site';


export const PAGE_SIZE = 10;

export const SUPPORTED_PAGES_CHATBOT_USECASES = [
  'sourcing',
  'application_inbound_web',
] as const;

const manageSitePagesSidePanelsName = [
  'details',
  'add-landing-pages',
  'add-external-site-pages',
  'page-settings',
];

// @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'ManageSitePageSidePanels[]'.
export const manageSitePagesSidePanels: ManageSitePageSidePanels[] = [
  ...manageSitePagesSidePanelsName,
];

export const addSectionOptions = [
  {
    key: 'video',
    label: 'Video',
  },
  {
    key: 'imageGallery',
    label: 'Image Gallery',
  },
  {
    key: 'title&Graph',
    label: 'Title and Graph',
  },
  {
    key: 'testimonials',
    label: 'Testimonials',
  },
  {
    key: 'forms',
    label: 'Forms',
  },
  {
    key: 'jobsList',
    label: 'Jobs List',
  },
] as const;

export const getPageOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'renamePage',
    label: t('Rename_Page', 'Rename Page'),
    iconLeft: 'text',
  },
  {
    key: 'pageSettings',
    label: t('Page_Settings', 'Page Settings'),
    iconLeft: 'gear',
  },
];

export const getPageChatbotOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'openChatbot',
    label: t('Open_Chatbot', 'Open Chatbot'),
    iconLeft: 'external-link',
  },
  {
    key: 'preview',
    label: t('Preview', 'Preview'),
    iconLeft: 'eye',
  },
  {
    key: 'change',
    label: t('Change', 'Change'),
    iconLeft: 'exchange',
  },
  {
    key: 'remove',
    label: t('Remove', 'Remove'),
    iconLeft: 'trash',
  },
];

export const getSiteOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'copy',
    label: t('Copy_URL', 'Copy URL'),
    iconLeft: 'copy',
  },
  {
    key: 'siteSettings',
    label: t('Site_Settings', 'Site Settings'),
    iconLeft: 'gear',
  },
  {
    key: 'duplicateSite',
    label: t('Duplicate_Site', 'Duplicate Site'),
    iconLeft: 'rectangle-history-circle-plus',
  },
  {
    key: 'deleteSite',
    label: t('Delete_Site', 'Delete Site'),
    iconLeft: 'trash',
  },
];

export const getMetaTags = (
  t: (arg1: string, arg2: string) => string,
): string[] => [
  t('Agile_Work', 'Agile Work'),
  t('ATS', 'ATS'),
  t('Campus_Recruitment', 'Campus Recruitment'),
  t('Career', 'Career'),
  t('Career_Fairs', 'Career Fairs'),
  t('Career_Growth', 'Career Growth'),
  t('Change_Management', 'Change Management'),
  t('Collaboration', 'Collaboration'),
  t('Compliance', 'Compliance'),
  t('Compensation', 'Compensation'),
  t('Consulting', 'Consulting'),
  t('Contract', 'Contract'),
  t('Customer_Service', 'Customer Service'),
  t('Diversity', 'Diversity'),
  t('Diversity_Recruitment', 'Diversity Recruitment'),
  t('Education', 'Education'),
  t('Employee_Engagement', 'Employee Engagement'),
  t('Employee_Referrals', 'Employee Referrals'),
  t('Employee_Relations', 'Employee Relations'),
  t('Employee_Wellness', 'Employee Wellness'),
  t('Employer_Branding', 'Employer Branding'),
  t('Employment', 'Employment'),
  t('Engineering', 'Engineering'),
  t('Executive_Search', 'Executive Search'),
  t('Finance', 'Finance'),
  t('FMCG', 'FMCG'),
  t('Flexible_Work', 'Flexible Work'),
  t('Freelance', 'Freelance'),
  t('Fulltime', 'Full-time'),
  t('Growth', 'Growth'),
  t('Healthcare', 'Healthcare'),
  t('HRIS', 'HRIS'),
  t('Hybrid', 'Hybrid'),
  t('Hybrid_Work', 'Hybrid Work'),
  t('Inclusion', 'Inclusion'),
  t('Innovation', 'Innovation'),
  t('Internship', 'Internship'),
  t('Interviewing', 'Interviewing'),
  t('IT', 'IT'),
  t('Job_Boards', 'Job Boards'),
  t('Jobs', 'Jobs'),
  t('Leadership', 'Leadership'),
  t('Leadership_Development', 'Leadership Development'),
  t('Labor_Law', 'Labor Law'),
  t('Logistics', 'Logistics'),
  t('Management', 'Management'),
  t('Manufacturing', 'Manufacturing'),
  t('Marketing', 'Marketing'),
  t('Mentorship', 'Mentorship'),
  t('Networking', 'Networking'),
  t('Networking_Events', 'Networking Events'),
  t('Onboarding', 'Onboarding'),
  t('Onsite', 'Onsite'),
  t('Openings', 'Openings'),
  t('Opportunity', 'Opportunity'),
  t('Organizational_Development', 'Organizational Development'),
  t('Parttime', 'Part-time'),
  t('Performance_Management', 'Performance Management'),
  t('Professional_Development', 'Professional Development'),
  t('Recruitment', 'Recruitment'),
  t('Remote', 'Remote'),
  t('Retail', 'Retail'),
  t('Salary', 'Salary'),
  t('Sales', 'Sales'),
  t('Screening', 'Screening'),
  t('Social_Media', 'Social Media'),
  t('Software', 'Software'),
  t('Sourcing', 'Sourcing'),
  t('Succession_Planning', 'Succession Planning'),
  t('Talent_Acquisition', 'Talent Acquisition'),
  t('Talent_Management', 'Talent Management'),
  t('Teamwork', 'Teamwork'),
  t('Technology', 'Technology'),
  t('Vacancy', 'Vacancy'),
  t('Wellness', 'Wellness'),
  t('Worklife_Balance', 'Work-life Balance'),
];

export const getAddPageOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'blankPage',
    label: t('Blank_Page', 'Blank Page'),
    iconLeft: 'page',
  },
  {
    key: 'importLandingPage',
    label: t('Import_a_Landing_Page', 'Import a Landing Page'),
    iconLeft: 'file-import',
  },
  {
    key: 'importPageFromOtherSite',
    label: t('Import_Page_from_Other_Site', 'Import Page from Other Site'),
    iconLeft: 'browser',
  },
];

export const getHeaderMenuOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {key: 'home', label: t('Home', 'Home')},
  {key: 'locations', label: t('Locations', 'Locations')},
  {key: 'departments', label: t('Departments', 'Departments')},
];

export const generateUUID = (): string => {
  // Public Domain/MIT
  let d = new Date().getTime(); //Timestamp
  let d2 =
    (typeof performance !== 'undefined' &&
      !!performance.now() &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export function removeWordFromString(
  inputString: string,
  wordToRemove: string,
): string {
  const words = inputString.split(' ');
  const filteredWords = words.filter((word) => word !== wordToRemove);
  const resultString = filteredWords.join(' ');
  return resultString;
}

export function flattenPages(
  pages: Array<SitePage>,
  siteName: string = '',
): Array<FlattenPage> {
  const flattenedPages: Array<FlattenPage> = [];
  pages.forEach((page) => {
    // Add parent page
    const parentPage: FlattenPage = {
      key: page.page_id?.toString() || '',
      label: page.name || '',
      isChild: false,
    };
    if (siteName.trim() !== '') {
      parentPage.siteName = siteName;
    }
    flattenedPages.push(parentPage);
    // Add children if present
    if (page.children && page.children.length > 0) {
      page.children.forEach((child) => {
        const childPage: FlattenPage = {
          key: child.page_id?.toString() || '',
          label: child.name || '',
          isChild: true,
        };
        if (siteName.trim() !== '') {
          childPage.siteName = siteName;
        }
        flattenedPages.push(childPage);
      });
    }
  });
  return flattenedPages;
}
